import { Injectable } from '@angular/core';
import * as Loggly from 'loggly-jslogger';
import { ConfigService } from './config.service';
import UAParser from 'ua-parser-js';

@Injectable({
  providedIn: 'root',
})
export class LogglyService {
  private loggly: any;

  constructor(private configService: ConfigService) {
    this.loggly = new Loggly.LogglyTracker();
    this.loggly.push({
      logglyKey: '5f65fd21-d472-48d0-adef-b696a6cbf960',
      sendConsoleErrors: true,
      tag: 'tobeonline-admin-mobile',
    });
  }

  public log(message: any) {
    const sellerDetails: any = this.getLoginDetails();
    const device = new UAParser();
    const uaDetails = device.getResult();
    this.loggly.push({
      log: message,
      level: 'info',
      pathUrl: window.location.href,
      version: this.configService.version,
      sellerName: sellerDetails?.SellerName,
      userAgent: uaDetails,
    });
  }

  public error(error: any) {
    const sellerDetails: any = this.getLoginDetails();
     const device = new UAParser();
    const uaDetails = device.getResult();
    this.loggly.push({
      level: 'error',
      error: error,
      message: error?.message || error,
      stack: error?.stack,
      pathUrl: window.location.href,
      version: this.configService.version,
      sellerName: sellerDetails?.SellerName,
      userAgent: uaDetails,
    });
  }

  public getLoginDetails() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? '{}');
  }
}
